import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Blocks Handwerker with unfinished onboarding from reaching routes other
 * than /onboarding and /dashboard.
 */
export const handwerkerOnboardingGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser;

  if (user === null) return true;
  if (user.rolle !== 'Handwerker') return true;
  if (user.onboardingAbgeschlossen) return true;

  const path = state.url.split('?')[0];
  if (path === '/onboarding' || path === '/dashboard') return true;

  return router.createUrlTree(['/onboarding']);
};
